import React from 'react';

const FormattedJsonDisplay = ({ data }) => {
  // Handle null or undefined data
  if (!data) {
    return <td className="px-6 py-4 text-sm text-gray-900">No data available</td>;
  }

  try {
    // Parse the JSON if it's a string, otherwise use the object directly
    const jsonData = typeof data === 'string' ? JSON.parse(data) : data;

    // Verify that jsonData is an object and not null
    if (typeof jsonData !== 'object' || jsonData === null) {
      return <td className="px-6 py-4 text-sm text-gray-900">Invalid data format</td>;
    }

    return (
      <td className="px-6 py-4 text-sm text-gray-900">
        <div className="flex flex-col space-y-1">
          {Object.entries(jsonData).map(([key, value]) => (
            <div key={key} className="flex">
              <span className="font-medium">{key}:</span>
              <span className="ml-2">
                {value !== null && value !== undefined 
                  ? value.toString()
                  : 'N/A'}
              </span>
            </div>
          ))}
        </div>
      </td>
    );
  } catch (error) {
    console.error('Error parsing JSON:', error);
    return <td className="px-6 py-4 text-sm text-gray-900">Error parsing data</td>;
  }
};

export default FormattedJsonDisplay;